import React, { useState, useEffect } from "react";
import Api from "../services/api";

export default function SelectCidades(props) {
  const [list, setList] = useState([]);

  useEffect(() => {
    loadCidades();
  }, []);

  function loadCidades() {
    Api.get("/cidades/list")
      .then((response) => {
        setList(response.data);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      });
  }

  let rows =
    list &&
    list.map((cidade, index) => {
      return (
        <option
          value={cidade.id}
          selected={props.selected == cidade.id ? true : false}
          key={index}
        >
          {cidade.nome}
        </option>
      );
    });

  return (
    <select {...props.register} onChange={props.handleChange}>
      <option></option>
      {rows}
    </select>
  );
}
